import React from "react";
import {
  PADDY_LAB_METRICS,
  formatLabLimitHint,
  formatPaddyLabMetric,
  paddyLabMetricClass,
} from "../../lib/paddyLabConfig";

export function PaddyLabMetricCell({ lab, metric, limits, showLimits = false, className = "" }) {
  const hint = showLimits ? formatLabLimitHint(limits, metric.key, metric.suffix.trim() || "%") : null;
  return (
    <div className={className}>
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{metric.label}</div>
      <div className={`text-xs tabular mt-0.5 ${paddyLabMetricClass(lab, metric.key)}`}>
        {formatPaddyLabMetric(lab, metric)}
      </div>
      {hint ? <div className="text-[10px] text-muted-foreground mt-0.5">{hint}</div> : null}
    </div>
  );
}

export function PaddyLabMetricsGrid({
  lab,
  limits = null,
  showLimits = false,
  columns = "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5",
  className = "",
}) {
  if (!lab) return null;
  return (
    <div className={`grid ${columns} gap-2 text-xs tabular ${className}`}>
      {PADDY_LAB_METRICS.map((m) => (
        <PaddyLabMetricCell key={m.key} lab={lab} metric={m} limits={limits} showLimits={showLimits} />
      ))}
      {lab.custom_param_1_name ? (
        <div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{lab.custom_param_1_name}</div>
          <div className="text-xs mt-0.5">{lab.custom_param_1_value || "—"}</div>
        </div>
      ) : null}
      {lab.custom_param_2_name ? (
        <div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{lab.custom_param_2_name}</div>
          <div className="text-xs mt-0.5">{lab.custom_param_2_value || "—"}</div>
        </div>
      ) : null}
    </div>
  );
}

export function PaddyLabMetricsList({ lab, limits = null, showLimits = false }) {
  if (!lab) return null;
  return (
    <div className="space-y-2 text-sm">
      {PADDY_LAB_METRICS.map((m) => {
        const hint = showLimits ? formatLabLimitHint(limits, m.key, m.suffix.trim() || "%") : null;
        return (
          <div key={m.key} className="flex justify-between items-center gap-3">
            <span className="text-muted-foreground">{m.label}</span>
            <span className={paddyLabMetricClass(lab, m.key, "tabular text-right")}>
              {formatPaddyLabMetric(lab, m)}
              {hint ? <span className="text-[10px] text-muted-foreground ml-2">({hint})</span> : null}
            </span>
          </div>
        );
      })}
      {lab.kachri_pct != null && lab.kachri_pct !== "" ? (
        <div className="flex justify-between items-center gap-3">
          <span className="text-muted-foreground">Kachri</span>
          <span className="tabular">{lab.kachri_pct}%</span>
        </div>
      ) : null}
    </div>
  );
}
